import { render, staticRenderFns } from "./layout-city-choice-popup.vue?vue&type=template&id=ca039910&scoped=true&"
import script from "./layout-city-choice-popup.vue?vue&type=script&lang=js&"
export * from "./layout-city-choice-popup.vue?vue&type=script&lang=js&"
import style0 from "./layout-city-choice-popup.vue?vue&type=style&index=0&id=ca039910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca039910",
  null
  
)

export default component.exports